import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BENEFITS } from "./data";

export const Benefits = () => (
    <section data-testid="benefits-section" className="bg-[#FDFBF7] py-24">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Trust &amp; Benefits</p>
            <h2 className="mt-3 max-w-xl font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Why brides across Chennai choose Monisha
            </h2>
            <div className="mt-14 grid gap-x-10 gap-y-6 sm:grid-cols-2 lg:grid-cols-3">
                {BENEFITS.map((benefit, i) => (
                    <motion.div
                        key={benefit}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: i * 0.06 }}
                        className="flex items-center gap-4"
                        data-testid={`benefit-item-${i}`}
                    >
                        <CheckCircle2 className="h-6 w-6 shrink-0 text-[#D4AF37]" />
                        <span className="text-base font-semibold text-[#2C2A29]">{benefit}</span>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
